import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as layoutActions from '../actions/layoutActions';
import {Link} from "react-router-dom";

export class CoursePage extends React.Component {
    componentDidMount() {
        this.props.actions.updatePageTitle("Developer's Course Home");
    }

    render() {
        return (
            <div>
                <p><Link to="EditProfile">Edit Profile</Link></p>
                <p><Link to="/">Logout</Link></p>
            </div>
        );
    }
}

CoursePage.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(layoutActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps) (CoursePage);